import { bootstrapQZ } from '@goshippo/print';

import { quickpackApi } from '~/services/api';

import { setupPrintLifecycleRelay } from './printLifecycle.util';

const getCertificate = (resolve, reject) => {
  quickpackApi
    .request<{ certificate: string }>({
      method: 'GET',
      url: '/devices/qz/certificate',
    })
    .then(({ data }) => resolve(data.certificate))
    .catch((error) => reject(error));
};

const sign = (toSign: string) => (resolve, reject) => {
  quickpackApi
    .request<{ signature: string }>({
      data: { to_sign: toSign },
      method: 'POST',
      url: '/devices/qz/signature',
    })
    .then(({ data }) => resolve(data.signature))
    .catch((error) => reject(error));
};

export const setupShippoPrint = () => {
  bootstrapQZ({ getCertificate, sign });
  setupPrintLifecycleRelay();
};
